import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { UliPdfPreviewModel, UliInformationPreviewStateModel } from '../models/uli-information-preview.model';
import { catchError, tap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { NotificationService } from '../../../../../../common/services/notification/notification.service';
import { UliPreviewInformationService } from './uli-preview-information.service';
import {
  UliPreviewInformationInitialState,
  UliPreviewInformationLoad,
  UliPreviewInformationSmsSend,
} from './uli-preview-information.actions';
import { Error, CustomHttpErrorResponse } from '../../../../../../common/constants/error';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

const initialState: UliInformationPreviewStateModel = {
  data: null,
  loaded: false,
};

@State<UliInformationPreviewStateModel>({
  name: 'uliInformationPreview',
  defaults: initialState,
})
@Injectable()
export class UliPreviewInformationState {
  @Selector()
  static getState(state: UliInformationPreviewStateModel): UliInformationPreviewStateModel {
    return state;
  }

  @Selector()
  static getData(state: UliInformationPreviewStateModel): UliPdfPreviewModel {
    return state.data;
  }

  @Selector()
  static getLoaded(state: UliInformationPreviewStateModel): boolean {
    return state.loaded;
  }

  constructor(
    private uliPreviewInformationService: UliPreviewInformationService,
    private notificationService: NotificationService,
  ) {}

  @Action(UliPreviewInformationLoad)
  getUliPreviewInformation(
    ctx: StateContext<UliInformationPreviewStateModel>,
    { payload }: UliPreviewInformationLoad,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | UliPdfPreviewModel> {
    return this.uliPreviewInformationService.getUliInformationPreview(payload).pipe(
      tap((data: UliPdfPreviewModel) => {
        ctx.patchState({
          data,
          loaded: true,
        });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(UliPreviewInformationSmsSend)
  sendSms(
    ctx: StateContext<UliInformationPreviewStateModel>,
    { payload }: UliPreviewInformationSmsSend,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.uliPreviewInformationService.sendSms(payload).pipe(
      tap(() => {
        this.notificationService.success('api.uli.success.sms');
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(UliPreviewInformationInitialState)
  setInitialState(ctx: StateContext<UliInformationPreviewStateModel>): void {
    ctx.setState(initialState);
  }
}
